
import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface DashboardCardProps {
  title: string;
  value?: string | number;
  icon?: ReactNode;
  trend?: {
    value: number;
    isPositive: boolean;
  };
  className?: string;
  children?: ReactNode;
  animationDelay?: string;
  onClick?: () => void;
}

export function DashboardCard({
  title,
  value,
  icon,
  trend,
  className,
  children,
  animationDelay,
  onClick,
}: DashboardCardProps) {
  return (
    <div 
      className={cn(
        "bg-card rounded-lg border border-border/50 p-4 shadow-subtle transition-all duration-200",
        "hover:shadow-md hover:border-border/80 hover:-translate-y-0.5",
        "animate-enter-dashboard",
        onClick && "cursor-pointer",
        className
      )}
      style={animationDelay ? { animationDelay } : undefined}
      onClick={onClick}
    >
      <div className="flex justify-between items-start mb-2">
        <h3 className="text-sm font-medium text-muted-foreground/90">{title}</h3>
        {icon && <div className="text-muted-foreground/80 transition-colors group-hover:text-primary">{icon}</div>}
      </div>

      {value && (
        <div className="flex items-baseline gap-2">
          <div className="text-2xl font-semibold tracking-tight">{value}</div>
          {trend && (
            <div className={cn(
              "text-xs font-medium flex items-center gap-1 transition-colors",
              trend.isPositive ? "text-success" : "text-destructive"
            )}>
              {trend.isPositive ? "+" : "-"}{Math.abs(trend.value)}%
            </div>
          )}
        </div>
      )}

      {children}
    </div>
  );
}
